import { theme, styled, css, u } from '../../shared/theming-sc'

const getHighlightTypestack = theme('mode', {
  refinitiv: css`
    font-size: 60px;
    line-height: 1.07;
    font-family: ${u.getFontFamily('knowledge', 'black')};

    ${u.media.greaterThan('sm')`
      font-size: 70px;
      line-height: 75px;
    `};
  `
})

const getHeadingTypestack = theme.variants('mode', 'size', {
  xl: {
    refinitiv: css`
      font-size: 38px;
      line-height: 1.32;
      font-family: ${p => u.getFontFamily('knowledge', p.weight || 'light')};

      ${u.media.greaterThan('sm')`
        font-size: 60px;
        line-height: 1.08;
      `};
    `
  },
  lg: {
    refinitiv: css`
      font-size: 38px;
      line-height: 50px;
    `
  },
  md: {
    refinitiv: css`
      font-size: 28px;
      line-height: 40px;
    `
  },
  mdlt: {
    refinitiv: css`
      font-size: 28px;
      line-height: 40px;
      font-weight: 400 !important
    `
  },
  sm: {
    refinitiv: css`
      font-size: 24px;
      line-height: 35px;
    `
  },
  xs: {
    refinitiv: css`
      font-size: 22px;
      line-height: 30px;
    `
  }
})

const getParagraphTypestack = theme.variants('mode', 'size', {
  lg: {
    refinitiv: css`
      font-size: 18px;
      line-height: 1.94;
    `
  },
  md: {
    refinitiv: css`
      font-size: 15px;
      line-height: 1.6;
    `
  },
  sm: {
    refinitiv: css`
      font-size: 13px;
      line-height: 1.54;
    `
  }
})

const getAlignProps = css`
  text-align: ${p => p.align};
`

const getHeadingBaseProps = theme('mode', {
  refinitiv: css`
    color: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    font-family: ${p => u.getFontFamily('knowledge', p.weight || 'light')};

    strong {
      font-family: ${p => u.getFontFamily('knowledge', p.weight || 'light')};
    }
  `
})

const StyledHeading = Component => styled(Component)`
  ${getHeadingBaseProps};
  ${getAlignProps};
  ${getHeadingTypestack};
  margin: 0;
`

const StyledHighlight = Component => styled(Component)`
  ${getHeadingBaseProps};
  ${getAlignProps};
  ${getHighlightTypestack};
`

const StyledParagraph = Component => styled(Component)`
  ${getAlignProps};
  ${getParagraphTypestack};
`

const StyledEyebrow = Component => styled(Component)`
  text-transform: uppercase;
  letter-spacing: 2px;
  ${getAlignProps};
  color: ${u.getColor('primary')};
  font-family: ${u.getFontFamily('knowledge', 'black')};
  font-size: 11px;
  line-height: 20px;
`

export { StyledEyebrow, StyledHeading, StyledHighlight, StyledParagraph }
